import React from "react";
import { Grid, Accordion, Pagination } from "semantic-ui-react";
import "../auth.css";
import "../card.css";
import "../sidemenu.css";
import { Link } from "react-router-dom";
import axios from "axios";
import { reactLocalStorage } from "reactjs-localstorage";
import i18n from "../i18n";
import { connect } from "react-redux";
import Menutest from "./menu.js";
import Table from "react-bootstrap/Table";
import {
  Message,
  Icon,
  Label,
  Menu,
  List,
  Segment,
  Header,
  Button,
  Divider,
  Input,
  Form,
  Card,
  Modal,
  TextArea,
  Checkbox,
  Radio,
  Item,
  Image,
} from "semantic-ui-react";
import { SemanticToastContainer, toast } from "react-semantic-toasts";
import Select from "react-select";

//import Modal from "react-modal";
import PhoneInput from "react-phone-input-2";
import { API_BASE_URL } from "../utils/endpoints";
// import "react-phone-input-2/dist/style.css";
var groupOptions = [];
//////////// editContact.js ////////////
var value_option = [];
var groupOptions = [];
var groups_array = [];
var data_group = [];

const formData = new FormData();
var total_success,
  total_failed = 0;

const AddContact = {
  height: "auto",
  width: 700,
  marginLeft: "30%",
  marginTop: 100,
};

const AddContacta = {
  height: "auto",
  width: 700,
  marginLeft: "15%",
  marginTop: 100,
};

const DeleteContact = {
  height: "auto",
  width: 700,
  marginLeft: "30%",
  marginTop: 200,
};

const DeleteContacta = {
  height: "auto",
  width: 700,
  marginLeft: "15%",
  marginTop: 200,
};

const filter = {
  marginTop: 150,
  marginLeft: "30%",
  height: "auto",
  textAlign: "left",
  width: 500,
};
const filtera = {
  marginTop: 150,
  marginLeft: "25%",
  height: "auto",
  textAlign: "left",
  width: 500,
};

class Invoices extends React.Component {
  state = { activeIndex: 0 };
  constructor(props) {
    super(props);
    this.state = {
      persons: [],
      personssearch: [],

      totalPages: 1,
      activePage: 1,

      searchtotalpage: 1,

      fromDate: new Date(),
      toDate: new Date(),
      filterTotalpage: 1,
      modalOpenFilterDetails: false,
    };
  }

  handleOpenFilterDetails = () =>
    this.setState({ modalOpenFilterDetails: true });
  handleCloseFilterDetails = () =>
    this.setState({ modalOpenFilterDetails: false });

  format(date) {
    const mydate = date;
    const datevalue = mydate.toLocaleDateString();

    var array = datevalue.split("/");
    var day = array[1];
    if (day < 10) {
      day = "0" + day;
    }
    var year = array[2];
    var month = array[0];
    if (month < 10) {
      month = "0" + month;
    }
    return year + "-" + month + "-" + day;
  }

  componentWillMount() {
    var token = reactLocalStorage.get("accessToken");
    //  var token = "eyJhbGciOiJIUzUxMiJ9.eyJpc3MiOiJjb3Jwc21zIiwic3ViIjoib3BlcmF0b3IxIiwiaWF0IjoxNjA0NTAxNzk4fQ.ksDpdgQPJedFGFZScUliJ-yF8asrLv915Kv3bLB_hwABFseaMvdCHq9TCczgs2-2CwcRMB1hbmxkpEJd_D5OLQ"

    var date = new Date();
    console.log(this.format(date), "date");
    var d = this.format(date);
    var array = d.split("-");
    var year = array[0];
    console.log(year);
    console.log(Number(year) - 1);
    var FromDate = array[0] + "-" + "01" + "-" + array[2];
    console.log(FromDate);

     var tofrom= new Date()
    var page_num =1;
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl = API_BASE_URL + `/core/user/rest/general/getInvoices?customerID=${reactLocalStorage.get(
        "customerID"
      )}&page=${page_num}&fromDate=${FromDate}&toDate=${this.format(date)}`;
    } else {
      apiBaseUrl =
        API_BASE_URL +
        `/core/user/rest/general/getInvoices?customerID=${reactLocalStorage.get('customerID')}&page=${page_num}&fromDate=${FromDate}&toDate=${this.format(date)}`;
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      if (res.data.status === "failed") {
        toast({
          type: "error",
          title: i18n.t("error.label"),
          description: i18n.t("Something_wrong.label"),
          animation: "bounce",
          time: 5000,
        });
      }
      if (res.data.result.invoices !== undefined) {
        if (res.data.result.invoices.length >= 0) {
          const persons = res.data.result.invoices;
          this.setState({
            persons: res.data.result.invoices,
            totalPages: res.data.result.totalPages,
          });
        } else {
          var array = [];
          this.setState({
            persons: array,
            totalPages: 1,
          });
        }
      }
      document.querySelector(".pagination").style = "display:block";
      document.querySelector(".filterpagination").style = "display:none";
    });
  }
  componentDidMount() {
    var lang = i18n.language;
    if (lang === "ar") {
      this.setState({ isArabic: true });
      document.querySelector(".darked_color").style =
        "text-align:right;width: 20%;white-space: pre;";

      document.querySelector(".ui.pagination.menu").style =
        "float: left !important; margin-left: 4% !important;";
      document.querySelector(".main_contact").style = "margin-right: 1%;";

      document.querySelector(".fixed_contact").style =
        "margin-right: 0% !important;";
    }
  }

  handlePaginationChange = (e, { activePage }) => {
    //  this.setState({ activePage });

    var token = reactLocalStorage.get("accessToken");
    // var token = "eyJhbGciOiJIUzUxMiJ9.eyJpc3MiOiJjb3Jwc21zIiwic3ViIjoib3BlcmF0b3IxIiwiaWF0IjoxNjA0NTAxNzk4fQ.ksDpdgQPJedFGFZScUliJ-yF8asrLv915Kv3bLB_hwABFseaMvdCHq9TCczgs2-2CwcRMB1hbmxkpEJd_D5OLQ"

    var page_num = activePage;
    
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl = API_BASE_URL + `/core/user/rest/general/getInvoices?customerID=${reactLocalStorage.get(
        "customerID"
      )}&page=${page_num}&fromDate=${this.format(
        this.state.fromDate
      )}&toDate=${this.format(this.state.toDate)}`;
    } else {
      apiBaseUrl =
        API_BASE_URL +
        `/core/user/rest/general/getInvoices?customerID=${reactLocalStorage.get('customerID')}&page=${page_num}&fromDate=${this.format(this.state.fromDate)}&toDate=${this.format(this.state.toDate)}`;
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      if (res.data.status === "failed") {
        toast({
          type: "error",
          title: i18n.t("error.label"),
          description: i18n.t("Something_wrong.label"),
          animation: "bounce",
          time: 5000,
        });
      }
      if (res.data.result.invoices !== undefined) {
        if (res.data.result.invoices.length >= 0) {
          const persons = res.data.result.invoices;
          this.setState({
            persons: res.data.result.invoices,
            totalPages: res.data.result.totalPages,
          });
        } else {
          var array = [];
          this.setState({
            persons: array,
            totalPages: 1,
          });
        }
      }
    });
  };

  filterData() {
    this.setState({ modalOpenFilterDetails: false });

    var token = reactLocalStorage.get("accessToken");
    //var token = "eyJhbGciOiJIUzUxMiJ9.eyJpc3MiOiJjb3Jwc21zIiwic3ViIjoib3BlcmF0b3IxIiwiaWF0IjoxNjA0NTAxNzk4fQ.ksDpdgQPJedFGFZScUliJ-yF8asrLv915Kv3bLB_hwABFseaMvdCHq9TCczgs2-2CwcRMB1hbmxkpEJd_D5OLQ"

    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    var page_num = 1;
    if (ip.includes(s2)) {
      apiBaseUrl = API_BASE_URL + `/core/user/rest/general/getInvoices?customerID=${reactLocalStorage.get(
        "customerID"
      )}&page=${page_num}&fromDate=${this.format(
        this.state.fromDate
      )}&toDate=${this.format(this.state.toDate)} `;
    } else {
      apiBaseUrl =
        API_BASE_URL +
        `/core/user/rest/general/getInvoices?customerID=${reactLocalStorage.get('customerID')}&page=${page_num}&fromDate=${this.format(this.state.fromDate)}&toDate=${this.format(this.state.toDate)} `;
    }

    var headers = { "Content-Type": "application/json", token: token };

    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      if (res.data.result.invoices != undefined) {
        if (res.data.result.invoices.length >= 0) {
          this.setState({
            persons: res.data.result.invoices,
          });
          this.setState({ filterTotalpage: res.data.result.totalPages });
        } else {
          var array = [];
          this.setState({
            persons: array,
            filterTotalpage: 1,
          });
        }
      }
      document.querySelector(".pagination").style = "display:none";
      document.querySelector(".filterpagination").style = "display:block";
    });
  }

  handlePaginationFilterChange = (e, { activePage }) => {
    this.setState({ activePage });
    //window.scrollTo(500, 0);
    var token = reactLocalStorage.get("accessToken");
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    var page_num = this.state.activePage;
    if (ip.includes(s2)) {
      apiBaseUrl = API_BASE_URL + `/core/user/rest/general/getInvoices?customerID=${reactLocalStorage.get(
        "customerID"
      )}&page=${page_num}&fromDate=${this.format(
        this.state.fromDate
      )}&toDate=${this.format(this.state.toDate)} `;
    } else {
      apiBaseUrl =
        API_BASE_URL +
        `/core/user/rest/general/getInvoices?customerID=${reactLocalStorage.get('customerID')}&page=${page_num}&fromDate=${this.format(this.state.fromDate)}&toDate=${this.format(this.state.toDate)} `;
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      if (res.data.result.invoices != undefined) {
        if (res.data.result.invoices.length >= 0) {
          this.setState({
            persons: res.data.result.invoices,
          });

          this.setState({ filterTotalpage: res.data.result.totalPages });
        } else {
          var array = [];
          this.setState({
            persons: array,
            filterTotalpage: 1,
          });
        }
      }
    });
  };

  onChangeFromDate = (event) => {
    const date = new Date(event.target.value);
    this.setState({ fromDate: date });
  };

  onChangeToDate = (event) => {
    const date = new Date(event.target.value);
    this.setState({ toDate: date });
  };

  render() {
    const { activeIndex } = this.state;
    const { activePage } = this.state;
    return (
      <div className="big_div">
        <Menutest />
        <div className="actionMenu">
          <div className="main_div_contact">
            <div className="main_contact ">
              <Grid columns={2} divided className="fixed_contact">
                <Grid.Row stretched className="fixed_header disable_z">
                  <Grid.Column className="grid_logo">
                    <Segment>
                      <h3 className="text_style darked_color">
                        {this.state.isArabic ? (
                          <img
                            src={require("../pictures/ArabicHedar.png")}
                            style={{
                              width: "100% !important",
                              height: "117px",
                              marginTop: "8px",
                              marginRight: "-13px",
                            }}
                            className="himage"
                          />
                        ) : (
                          <img
                            src={require("../pictures/EnglishHedar.png")}
                            style={{
                              width: "100% !important",
                              height: "117px",
                              marginLeft: "-13px",
                              marginTop: "8px",
                            }}
                            className="himage"
                          />
                        )}
                      </h3>
                    </Segment>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </div>
          </div>

          <br />
          <br />
          <br />
          <br />
          <div
            className="container_cards"
            style={{ paddingRight: this.state.isArabic ? "" : "20px" }}
          >
            <div
              className={
                this.state.isArabic ? "content_reportarabic" : "content_report"
              }
            >
              <br />
              <Segment
                color="black"
                style={{ padding: "20px", minHeight: "200px" }}
              >
                <br />

                <Divider horizontal>
                  <Header as="h2">
                    <Icon name="wpforms" size="tini" color="black" />

                    {this.state.isArabic ? "فواتير" : "Invoices"}
                  </Header>
                </Divider>
                <br />

                <div className="buttonsHeader">
                  <Button
                    floated="right"
                    icon
                    labelPosition="left"
                    basic
                    size="small"
                    onClick={this.handleOpenFilterDetails}
                  >
                    <Icon name="sort amount up" /> {i18n.t("filter.label")}
                  </Button>
                  <Button
                    floated="right"
                    icon
                    labelPosition="left"
                    basic
                    size="small"
                    onClick={() => {
                      this.componentWillMount();
                    }}
                  >
                    <Icon name="refresh" />{" "}
                    {this.state.isArabic ? "تحديث" : "Refresh"}
                  </Button>
                </div>

                <br />
                <br />
                <Table
                  hover
                  responsive
                  border="0"
                  style={{ textAlign: this.state.isArabic ? "right" : "left" }}
                >
                  <thead className="head">
                    <tr>
                      <td style={{ textAlign: "center" }}>
                        {" "}
                        {this.state.isArabic
                          ? "رقم الفاتورة"
                          : "Invoice Reference Number"}{" "}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {" "}
                        {this.state.isArabic ? "التاريخ" : "Date"}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {" "}
                        {this.state.isArabic ? "الكمية" : "Amount"}{" "}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {" "}
                        {this.state.isArabic
                          ? "رقم المشترك"
                          : "Subscriber MSISDN"}{" "}
                      </td>
                    </tr>
                  </thead>
                  {this.state.persons.map((person) => (
                    <tbody>
                      <tr>
                        <td style={{ textAlign: "center" }}>
                          {person.invoiceReferenceNumber}
                        </td>
                        <td style={{ textAlign: "center" }}>{person.date}</td>

                        <td style={{ textAlign: "center" }}>{person.amount}</td>

                        <td style={{ textAlign: "center" }}>
                          {person.subscriberMSISDN}
                        </td>
                      </tr>
                    </tbody>
                  ))}
                </Table>

                <div className="pagination" style={{ display: "block" }}>
                  <Segment basic />
                  <Divider horizontal>
                    <Header
                      as="h5"
                      floated={this.state.isArabic ? "left" : "right"}
                    >
                      <Pagination
                        defaultActivePage={1}
                        onPageChange={this.handlePaginationChange}
                        totalPages={this.state.totalPages}
                        className="page_contact"
                      />
                    </Header>
                  </Divider>
                </div>

                <div className="filterpagination" style={{ display: "none" }}>
                  {" "}
                  <Segment basic />
                  <Divider horizontal>
                    <Header
                      as="h5"
                      floated={this.state.isArabic ? "left" : "right"}
                    >
                      <Pagination
                        defaultActivePage={1}
                        onPageChange={this.handlePaginationFilterChange}
                        totalPages={this.state.filterTotalpage}
                        className="page_contact"
                      />
                    </Header>
                  </Divider>
                </div>
              </Segment>
            </div>

            {/* //////////////////////////////////////////////////////////////////////////////////////////////// */}
          </div>

          <div className="viewBox" style={{ display: "none" }}>
            <Message icon className="download_box_contact">
              <Icon name="circle notched" loading />
              <Message.Content>
                <Message.Header>Wait for downloading</Message.Header>
                {this.state.viewDatadownload}
              </Message.Content>
            </Message>
          </div>
        </div>

        <SemanticToastContainer />
        <Modal
          closeIcon={{
            style: { top: "0rem", right: "0rem" },
            color: "black",
            name: "close",
          }}
          size="large"
          open={this.state.modalOpenFilterDetails}
          onClose={this.handleCloseFilterDetails}
          className="add"
          style={this.state.isArabic ? filtera : filter}
        >
          <Header content="Filter" />
          <Modal.Content scrolling>
            <label
              htmlFor="defaultFormCardNameEx"
              className="grey-text font-weight-light"
              style={{ float: this.state.isArabic ? "right" : "left" }}
            >
              {i18n.t("start_date.label")}
            </label>
            <br />
            <input
              type="datetime-local"
              onChange={this.onChangeFromDate}
              className="dateinput"
            />

            <br />

            <label
              htmlFor="defaultFormCardNameEx"
              className="grey-text font-weight-light"
              style={{ float: this.state.isArabic ? "right" : "left" }}
            >
              <br />
              {i18n.t("end_date.label")}
            </label>
            <input
              type="datetime-local"
              onChange={this.onChangeToDate}
              className="dateinput"
            />

            <br />
          </Modal.Content>
          <Modal.Actions>
            <Button
              basic
              color="teal"
              content={i18n.t("Submit.label")}
              onClick={() => {
                this.filterData();
              }}
            />
            <Button
              basic
              color="black"
              content={i18n.t("Cancel.label")}
              onClick={this.handleCloseFilterDetails}
            />
          </Modal.Actions>
        </Modal>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return { ...state };
};
export default connect(mapStateToProps)(Invoices);
